import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import Rating from '@/components/base/Rating';

interface HotListProps {
  movies: Movie[];
}

export default function HotList({ movies }: HotListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center gap-2">
        <i className="ri-fire-line text-xl text-accent-500" aria-hidden="true" />
        <h2 className="font-heading text-lg font-bold text-foreground-950">热门推荐榜</h2>
      </div>
      <p className="mt-1 font-label text-xs text-foreground-500">按站内热度实时排序</p>

      <ol className="mt-4 flex flex-col gap-3">
        {movies.map((movie, i) => (
          <li key={movie.id}>
            <Link
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-secondary-100 cursor-pointer"
            >
              <span
                className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                  i < 3 ? 'bg-accent-500 text-primary-950' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {i + 1}
              </span>
              <span className="h-14 w-10 flex-shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title}`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
                  {movie.title}
                </span>
                <span className="mt-0.5 block truncate font-label text-xs text-foreground-600">
                  {movie.year} · {movie.genres[0]}
                </span>
                <span className="mt-0.5 line-clamp-1 block text-xs text-foreground-500">
                  {movie.summary}
                </span>
              </span>
              <Rating value={movie.rating} />
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}